import React, { useState } from "react";

export default function ZeytinHesapWordPressMockup({ initialPage = "home" }) {
  const [page, setPage] = useState(initialPage);
  const publicPageThemeClass = {
    home: "landing-bg landing-bg-home",
    features: "landing-bg landing-bg-features",
    contact: "landing-bg landing-bg-contact",
    register: "landing-bg landing-bg-register",
    login: "landing-bg landing-bg-login",
  }[page] || "";
  const API_BASE_URL = "http://localhost:4000/api/v1";
  const AUTH_KEY = "zeytinhesap_auth";
  const [loginPhone, setLoginPhone] = useState("");
  const [loginPassword, setLoginPassword] = useState("");
  const [loginError, setLoginError] = useState("");
  const [registerName, setRegisterName] = useState("");
  const [registerEmail, setRegisterEmail] = useState("");
  const [registerPhone, setRegisterPhone] = useState("");
  const [registerPassword, setRegisterPassword] = useState("");
  const [registerError, setRegisterError] = useState("");
  const [registerSuccess, setRegisterSuccess] = useState("");
  const [isRegisterLoading, setIsRegisterLoading] = useState(false);
  const isRegisterSectionDisabled = true;
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handlePanelLogin = async () => {
    const email = loginPhone.trim();
    const password = loginPassword;
    const normalizedEmail = email.toLowerCase();
    const isZeroTestLogin = email === "0" && password === "0";
    const isDenemeTestLogin = normalizedEmail === "deneme" && password === "deneme";
    const isZiyaretciLogin = email === "1234" && password === "1234";
    const ziyaretciExpiry = new Date("2026-09-09T23:59:59");
    const testEmail = "test0@zeytinhesap.local";
    const testPassword = "000000";
    const denemeEmail = "deneme@zeytinhesap.local";
    const denemePassword = "deneme";
    const ziyaretciEmail = "ziyaretci@zeytinhesap.local";
    const ziyaretciPassword = "ziyaretci2026";

    const effectiveEmail = isZeroTestLogin
      ? testEmail
      : isDenemeTestLogin
        ? denemeEmail
        : isZiyaretciLogin
          ? ziyaretciEmail
          : email;
    const effectivePassword = isZeroTestLogin
      ? testPassword
      : isDenemeTestLogin
        ? denemePassword
        : isZiyaretciLogin
          ? ziyaretciPassword
          : password;

    if (!email || !password) {
      setLoginError("E-posta ve şifre zorunludur.");
      return;
    }

    if (isZiyaretciLogin && new Date() > ziyaretciExpiry) {
      setLoginError("Ziyaretçi demo hesabının süresi dolmuştur (09.09.2026).");
      return;
    }

    setLoginError("");

    // Backend tamamen kapalıysa demo girişlerde local olarak panele yönlendir
    if (isZeroTestLogin || isDenemeTestLogin || isZiyaretciLogin) {
      const fakeUser = {
        email: effectiveEmail,
        name: isDenemeTestLogin ? "Deneme Kullanici" : isZiyaretciLogin ? "Ziyaretci Demo" : "Test Kullanici 0",
        demo: true
      };
      localStorage.setItem(AUTH_KEY, JSON.stringify({ token: "demo-token", user: fakeUser }));
      window.location.href = "/panel";
      return;
    }
    // Diğer girişlerde backend kapalıysa hata göster
    setLoginError("Sunucuya bağlanılamadı. Backend açık mı kontrol edin.");
  };

  const handleRegister = async () => {
    const name = registerName.trim();
    const email = registerEmail.trim();
    const phone = registerPhone.trim();
    const password = registerPassword;

    if (!name || !email || !password) {
      setRegisterError("Ad Soyad, E-posta ve Şifre zorunludur.");
      setRegisterSuccess("");
      return;
    }

    setIsRegisterLoading(true);
    setRegisterError("");
    setRegisterSuccess("");

    try {
      const response = await fetch(`${API_BASE_URL}/auth/register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name, email, phone, password }),
      });
      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        setRegisterError(data.error || "Kayıt oluşturulamadı.");
        return;
      }

      setRegisterSuccess("Kayıt başarıyla oluşturuldu. Giriş sayfasına yönlendiriliyorsunuz...");
      setLoginPhone(email);
      setLoginPassword(password);
      setRegisterName("");
      setRegisterEmail("");
      setRegisterPhone("");
      setRegisterPassword("");
      setTimeout(() => setPage("login"), 600);
    } catch {
      setRegisterError("Sunucuya bağlanılamadı. Backend açık mı kontrol edin.");
    } finally {
      setIsRegisterLoading(false);
    }
  };

  const stats = [
    { label: "Aktif Kullanıcı Sayısı", value: "+97" },
    { label: "Toplam KG", value: "926.347 kg" },
    { label: "Ortalama Fiyat", value: "₺96,80" },
    { label: "Teslim Edilen Kasa", value: "44.112" },
  ];

  const baseSellers = [
    { name: "Ahmet Yılmaz", phone: "0507 111 22 33" },
    { name: "Ayşe Korkmaz", phone: "0534 101 20 30" },
    { name: "Burak Öztürk", phone: "0535 202 30 40" },
    { name: "Cem Arslan", phone: "0536 303 40 50" },
    { name: "Mehmet Kaya", phone: "0532 444 55 66" },
    { name: "Hasan Demir", phone: "0541 888 11 22" },
    { name: "Ali Çelik", phone: "0553 222 33 44" },
    { name: "Serkan Aydın", phone: "0537 404 50 60" },
    { name: "Mustafa Şahin", phone: "0542 666 77 88" },
    { name: "Zeynep Kara", phone: "0538 505 60 70" },
  ];

  const defaultDeliveries = [
    { seller: "Ahmet Yılmaz", type: "Trilya", kg: 320 },
    { seller: "Mehmet Kaya", type: "Edremit", kg: 210 },
    { seller: "Ali Çelik", type: "Uslu", kg: 180 },
    { seller: "Mustafa Şahin", type: "Domat", kg: 160 },
    { seller: "Hasan Demir", type: "Tekir", kg: 200 },
    { seller: "Ayşe Korkmaz", type: "Domat", kg: 175 },
    { seller: "Burak Öztürk", type: "Edremit", kg: 155 },
    { seller: "Cem Arslan", type: "Tekir", kg: 145 },
    { seller: "Serkan Aydın", type: "Trilya", kg: 135 },
    { seller: "Zeynep Kara", type: "Uslu", kg: 150 },
  ];

  const oliveTypes = ["Trilya", "Edremit", "Uslu", "Domat", "Tekir"];



  const [classes] = useState([
    { label: "Duble", kg: 120, price: 100 },
    { label: "No:1", kg: 140, price: 90 },
    { label: "No:2", kg: 80, price: 80 },
    { label: "No:3", kg: 60, price: 70 },
    { label: "No:4", kg: 40, price: 60 },
    { label: "Yağlık", kg: 70, price: 30 },
  ]);

  const expenses = [
    { item: "İşçilik", amount: 18500 },
    { item: "Nakliye", amount: 9200 },
    { item: "Akaryakıt", amount: 4800 },
    { item: "Elektrik", amount: 3500 },
    { item: "Diğer", amount: 2200 },
  ];

  // --- Satıcı Yönetimi state ---
  const [sellerName,setSellerName] = useState("");
  const [sellerPhone,setSellerPhone] = useState("");
  const [addedSellers,setAddedSellers] = useState([]);

  const addSeller = () => {
    if(!sellerName) return;
    const newSeller = {name:sellerName, phone:sellerPhone};
    setAddedSellers([...addedSellers,newSeller]);
    setSellerName("");
    setSellerPhone("");

    setTimeout(()=>{
      const el=document.getElementById("seller-list");
      if(el) el.scrollIntoView({behavior:"smooth"});
    },100);
  };

  // --- Teslim Yönetimi state ---
  const [deliverySeller,setDeliverySeller] = useState("");
  const [deliveryType,setDeliveryType] = useState("");
  const [deliveryKg,setDeliveryKg] = useState("");
  const [deliveries,setDeliveries] = useState([]);

  // --- Demirbaş state ---
  const [assetCompany,setAssetCompany] = useState("");
  const [assetCrateCount,setAssetCrateCount] = useState("");
  const [assetType,setAssetType] = useState("");
  const [assetKg,setAssetKg] = useState("");
  const [assetPrice,setAssetPrice] = useState("");
  const [assets,setAssets] = useState([]);

  const addDelivery = () => {
    const parsedKg = Number(deliveryKg);
    if(!deliverySeller || !parsedKg) return;
    const newDelivery={seller:deliverySeller,type:deliveryType,kg:parsedKg};
    setDeliveries([...deliveries,newDelivery]);

    setDeliverySeller("");
    setDeliveryType("");
    setDeliveryKg("");

    setTimeout(()=>{
      const el=document.getElementById("delivery-list");
      if(el) el.scrollIntoView({behavior:"smooth"});
    },100);
  };

  const addAsset = () => {
    const parsedCrate = Number(assetCrateCount);
    const parsedKg = Number(assetKg);
    const parsedPrice = Number(assetPrice);

    if (!assetCompany || !assetType || !parsedCrate || !parsedKg || !parsedPrice) return;

    const newAsset = {
      company: assetCompany,
      crateCount: parsedCrate,
      type: assetType,
      kg: parsedKg,
      price: parsedPrice,
      total: parsedKg * parsedPrice,
    };

    setAssets([...assets, newAsset]);
    setAssetCompany("");
    setAssetCrateCount("");
    setAssetType("");
    setAssetKg("");
    setAssetPrice("");
  };

  const allDeliveries = [...defaultDeliveries, ...deliveries];
  const totalKg = allDeliveries.reduce((sum, d) => sum + Number(d.kg || 0), 0);
  const classWeightTotal = classes.reduce((sum, c) => sum + c.kg, 0);
  const distributedClasses = classes.map((c) => ({
    ...c,
    calcKg: classWeightTotal ? (totalKg * c.kg) / classWeightTotal : 0,
  }));
  const totalAmount = distributedClasses.reduce((sum, c) => sum + c.calcKg * c.price, 0);
  const totalExpenses = expenses.reduce((sum, e) => sum + e.amount, 0);
  const netAmount = totalAmount - totalExpenses;
  const totalAssetAmount = assets.reduce((sum, a) => sum + a.total, 0);
  const avgPrice = totalKg ? (totalAmount / totalKg).toFixed(2) : 0;
  const kgPerCrate = 22;
  const totalCrates = totalKg / kgPerCrate;

  const sellerKgMap = allDeliveries.reduce((acc, d) => {
    const key = d.seller;
    acc[key] = (acc[key] || 0) + Number(d.kg || 0);
    return acc;
  }, {});

  const sellerPhoneMap = [...baseSellers, ...addedSellers].reduce((acc, s) => {
    acc[s.name] = s.phone;
    return acc;
  }, {});

  const sellers = Object.entries(sellerKgMap)
    .map(([name, kg]) => ({
      name,
      phone: sellerPhoneMap[name] || "-",
      kg,
      total: `₺${Math.round(kg * Number(avgPrice)).toLocaleString("tr-TR")}`,
    }))
    .sort((a, b) => a.name.localeCompare(b.name, "tr"));

  const sortedAllDeliveries = [...allDeliveries].sort((a, b) =>
    String(a.seller || "").localeCompare(String(b.seller || ""), "tr")
  );

  const varietyTotals = Object.entries(
    allDeliveries.reduce((acc, d) => {
      const key = d.type && String(d.type).trim() ? d.type : "Belirtilmedi";
      acc[key] = (acc[key] || 0) + Number(d.kg || 0);
      return acc;
    }, {})
  )
    .map(([type, kg]) => ({ type, kg }))
    .sort((a, b) => b.kg - a.kg);

  const sellerOptions = [...new Set([...baseSellers, ...addedSellers].map((s) => s.name))]
    .sort((a, b) => a.localeCompare(b, "tr"));

  const features = [
    {
      title: "Satıcı Yönetimi",
      text: "Telefon numarası ile satıcı kaydı oluşturma, geçmiş teslimleri görüntüleme ve toplam alış verilerini takip etme.",
    },
    {
      title: "Zeytin Teslim Kayıtları",
      text: "Her teslim için çeşit, sınıf, kilogram ve fiyat girilerek otomatik toplam hesaplama yapılır.",
    },
    {
      title: "Otomatik Hesaplama",
      text: "Duble, No:1, No:2, No:3, No:4 ve Yağlık sınıfları için Kg × Fiyat otomatik hesaplanır.",
    },
    {
      title: "Rapor Sistemi",
      text: "Günlük alım raporları, satıcı bazlı toplamlar ve PDF rapor çıktıları.",
    },
    {
      title: "Çok Kullanıcılı Sistem",
      text: "Her kullanıcı kendi satıcı ve teslim kayıtlarını ayrı şekilde saklar.",
    },
    {
      title: "SaaS Üyelik Yapısı",
      text: "Deneme süresi, yıllık üyelik ve admin kontrol sistemi.",
    },
  ];

  const packages = [
    {
      name: "3 Günlük Deneme",
      price: "3 Gün Ücretsiz",
      items: ["Sınırlı kullanım", "Sınırlı teslim kaydı"],
    },
    {
      name: "Yıllık Kullanım",
      price: "Kurumsal Paket",
      items: ["1 yıl kullanım", "Sınırsız satıcı kaydı", "Rapor sistemi", "Teknik destek"],
    },
    {
      name: "Bayilik",
      price: "Özel Teklif",
      items: ["Çoklu kullanıcı", "Yönetim paneli", "Özel fiyatlandırma"],
    },
  ];

  return (
    <div className="h-screen overflow-hidden bg-stone-100 text-stone-900 flex flex-col">
      <header className="border-b border-stone-200 bg-white shrink-0">
        <div className="mx-auto max-w-7xl flex items-center justify-between px-4 md:px-6 py-3 gap-4">
          <div className="text-xl font-black">www.zeytinhesap.com</div>

          {/* Masaüstü nav */}
          <nav className="hidden md:flex gap-3 text-sm font-semibold">
            <button
              onClick={() => setPage("home")}
              className={`px-3 py-2 rounded-lg transition ${
                page === "home" ? "bg-green-700 text-white" : "text-stone-700 hover:bg-stone-100"
              }`}
            >
              Ana Sayfa
            </button>
            <button
              onClick={() => setPage("features")}
              className={`px-3 py-2 rounded-lg transition ${
                page === "features" ? "bg-green-700 text-white" : "text-stone-700 hover:bg-stone-100"
              }`}
            >
              Özellikler
            </button>
            <button
              onClick={() => setPage("demo")}
              className={`px-3 py-2 rounded-lg transition ${
                page === "demo" ? "bg-green-700 text-white" : "text-stone-700 hover:bg-stone-100"
              }`}
            >
              Demo
            </button>
            <button
              onClick={() => setPage("contact")}
              className={`px-3 py-2 rounded-lg transition ${
                page === "contact" ? "bg-green-700 text-white" : "text-stone-700 hover:bg-stone-100"
              }`}
            >
              İletişim
            </button>
            <button
              onClick={() => setPage("register")}
              className="bg-green-700 text-white px-5 py-2 rounded-lg font-bold shadow"
            >
              Kayıt
            </button>
            <button
              onClick={() => { setPage("login"); setLoginPhone("1234"); setLoginPassword("1234"); }}
              className="bg-red-600 text-white px-5 py-2 rounded-lg font-bold shadow hover:bg-red-700"
            >
              Giriş
            </button>
          </nav>

          {/* Mobil hamburger butonu */}
          <button
            className="md:hidden p-2 rounded-lg text-stone-700 hover:bg-stone-100 text-2xl leading-none"
            onClick={() => setMobileMenuOpen(v => !v)}
            aria-label="Menü"
          >
            {mobileMenuOpen ? "✕" : "☰"}
          </button>
        </div>

        {/* Mobil açılır menü */}
        {mobileMenuOpen && (
          <div className="md:hidden border-t border-stone-200 bg-white px-4 py-3 flex flex-col gap-2 text-sm font-semibold">
            {[
              { key: "home", label: "Ana Sayfa" },
              { key: "features", label: "Özellikler" },
              { key: "demo", label: "Demo" },
              { key: "contact", label: "İletişim" },
            ].map(({ key, label }) => (
              <button
                key={key}
                onClick={() => { setPage(key); setMobileMenuOpen(false); }}
                className={`w-full text-left px-4 py-3 rounded-xl transition ${
                  page === key ? "bg-green-700 text-white" : "text-stone-700 bg-stone-50 hover:bg-stone-100"
                }`}
              >
                {label}
              </button>
            ))}
            <button
              onClick={() => { setPage("register"); setMobileMenuOpen(false); }}
              className="w-full text-left px-4 py-3 rounded-xl bg-green-700 text-white font-bold"
            >
              Kayıt
            </button>
            <button
              onClick={() => { setPage("login"); setLoginPhone("1234"); setLoginPassword("1234"); setMobileMenuOpen(false); }}
              className="w-full text-left px-4 py-3 rounded-xl bg-red-600 text-white font-bold"
            >
              Giriş
            </button>
          </div>
        )}
      </header>

      <main className={`flex-1 ${page === "demo" ? "overflow-hidden" : "overflow-y-auto"} ${publicPageThemeClass}`}>
        {page === "home" && (
          <div className="mx-auto max-w-7xl w-full p-4 flex flex-col gap-3 public-page-shell">
            <div className="bg-gradient-to-br from-green-700 via-green-600 to-lime-500 text-white rounded-2xl p-6 shadow-2xl">
              <div className="max-w-3xl">
                <div className="text-xs uppercase tracking-widest bg-white/20 inline-block px-3 py-1 rounded-full">
                  ZEYTİNHESAP SİSTEMİ
                </div>

                <h1 className="text-3xl md:text-4xl font-black mt-3 leading-tight">
                  Zeytin Alımınızı
                  <br />
                  Tek Panelden
                  <br />
                  Yönetin
                </h1>

                <p className="mt-2 text-green-100 text-sm max-w-xl">
                  Satıcı kayıtları, zeytin teslimleri, kilogram hesaplama ve günlük raporları tek ekrandan yönetin.
                  Zeytin alım yapan işletmeler için geliştirililmiş modern ve hızlı bir takip sistemi.
                </p>

                <div className="flex gap-3 mt-4 flex-wrap">
                  <button
                    onClick={() => setPage("demo")}
                    className="bg-white text-green-900 px-5 py-2 rounded-xl font-bold shadow hover:scale-105 transition"
                  >
                    Demo İncele
                  </button>
                  <button
                    onClick={() => setPage("contact")}
                    className="border border-white px-5 py-2 rounded-xl font-semibold hover:bg-white/10"
                  >
                    Bilgi Al
                  </button>
                </div>
              </div>
            </div>

            <div className="grid md:grid-cols-4 grid-cols-2 gap-3">
              {stats.map((s) => (
                <div key={s.label} className="bg-white rounded-xl p-4 shadow border border-stone-200 text-center">
                  <div className="text-xs text-stone-500 uppercase tracking-wide">{s.label}</div>
                  <div className="text-xl font-black text-green-700 mt-1">{s.value}</div>
                </div>
              ))}
            </div>

            <div className="bg-white rounded-2xl p-5 shadow border border-stone-200">
              <div className="text-center mb-4">
                <div className="text-xs uppercase tracking-widest bg-green-100 text-green-700 inline-block px-3 py-1 rounded-full">
                  NEDEN ZEYTİNHESAP
                </div>
                <h2 className="text-xl font-black mt-2">Zeytin Alım Sürecini Kolaylaştırır</h2>
              </div>

              <div className="grid md:grid-cols-3 gap-4 text-center">
                <div className="bg-green-50 p-4 rounded-xl">
                  <div className="text-2xl mb-1">⚡</div>
                  <div className="font-bold">Hızlı Veri Girişi</div>
                  <div className="text-sm text-stone-600 mt-1">Satıcı ve teslim kayıtlarını saniyeler içinde oluşturun.</div>
                </div>
                <div className="bg-green-50 p-4 rounded-xl">
                  <div className="text-2xl mb-1">📊</div>
                  <div className="font-bold">Anlık Hesaplama</div>
                  <div className="text-sm text-stone-600 mt-1">Kg × Fiyat otomatik hesaplanır, hataları önler.</div>
                </div>
                <div className="bg-green-50 p-4 rounded-xl">
                  <div className="text-2xl mb-1">☁️</div>
                  <div className="font-bold">Bulut Sistem</div>
                  <div className="text-sm text-stone-600 mt-1">Tüm veriler güvenli şekilde saklanır ve her yerden erişilir.</div>
                </div>
              </div>
            </div>
          </div>
        )}

        {page === "login" && (
          <div className="mx-auto max-w-6xl h-full w-full flex items-center justify-center p-6 overflow-auto public-page-shell">
            <div className="grid md:grid-cols-2 gap-8 w-full max-w-5xl">

              <div className="bg-gradient-to-br from-green-800 via-green-700 to-lime-600 text-white rounded-3xl p-10 shadow-2xl flex flex-col justify-between relative overflow-hidden">
                <div className="absolute -top-20 -right-20 w-72 h-72 bg-green-300 rounded-full blur-3xl opacity-30"></div>
                <div className="absolute -bottom-20 -left-20 w-72 h-72 bg-lime-300 rounded-full blur-3xl opacity-30"></div>

                <div>
                  <div className="text-xs uppercase tracking-widest bg-white/20 inline-block px-3 py-1 rounded-full">
                    ZeytinHesap
                  </div>

                  <h2 className="text-4xl font-black mt-6 leading-tight">
                    Zeytin Alım
                    <br />
                    Takip Paneli
                  </h2>

                  <p className="text-green-100 text-sm mt-4 leading-relaxed">
                    Satıcı kayıtları, teslim alımları ve kilogram hesaplamalarını
                    tek panelden yönetin.
                  </p>

                  <div className="grid grid-cols-3 gap-3 mt-8 text-xs text-center">
                    <div className="bg-white/10 p-3 rounded-lg">⚡ Hızlı</div>
                    <div className="bg-white/10 p-3 rounded-lg">📊 Rapor</div>
                    <div className="bg-white/10 p-3 rounded-lg">☁️ Bulut</div>
                  </div>
                </div>

                <div className="mt-10">
                  <div className="text-3xl font-black tracking-wide">0507 117 69 97</div>
                  <div className="text-xs text-green-100 mt-2">Destek hattı</div>
                </div>
              </div>

              <div className="bg-white rounded-3xl p-10 shadow-xl border border-stone-200">
                <div className="text-center mb-8">
                  <div className="text-xs uppercase tracking-widest bg-amber-100 text-amber-800 inline-block px-3 py-1 rounded-full font-bold">
                    Ziyaretçi girişi: e-posta <span className="font-black">1234</span> · şifre <span className="font-black">1234</span>
                  </div>
                  <h1 className="text-3xl font-black mt-4">Panel Girişi</h1>
                  <p className="text-stone-500 text-sm mt-2">
                    Zeytin alım sistemine erişmek için giriş yapın.
                  </p>
                </div>

                <div className="space-y-4">
                  <input
                    type="text"
                    placeholder="E-posta"
                    value={loginPhone}
                    onChange={(e) => setLoginPhone(e.target.value)}
                    className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-green-600 outline-none"
                  />

                  <input
                    type="password"
                    placeholder="Şifre"
                    value={loginPassword}
                    onChange={(e) => setLoginPassword(e.target.value)}
                    className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-green-600 outline-none"
                  />

                  <button
                    onClick={handlePanelLogin}
                    className="w-full bg-green-700 text-white p-3 rounded-xl font-bold shadow-lg hover:bg-green-800 hover:scale-[1.02] transition"
                  >
                    Giriş Yap
                  </button>

                  {loginError && (
                    <div className="text-center text-xs text-red-600">{loginError}</div>
                  )}

                  <div className="text-center text-xs text-stone-400 pt-2">
                    Şifrenizi mi unuttunuz?
                  </div>
                </div>

                <div className="mt-10">
                  <div className="text-center mb-4">
                    <div className="text-xs uppercase tracking-widest bg-green-100 text-green-700 inline-block px-3 py-1 rounded-full">
                      Paketler
                    </div>
                    <div className="text-lg font-bold mt-2">Kullanım Seçenekleri</div>
                  </div>

                  <div className="grid grid-cols-3 gap-3 text-xs">
                    {packages.map((p) => (
                      <div key={p.name} className="border rounded-xl p-3 text-center bg-stone-50">
                        <div className="font-bold text-sm">{p.name}</div>
                        <div className="text-green-700 font-semibold text-xs mb-2">{p.price}</div>
                        <ul className="space-y-1 text-stone-600 mb-2">
                          {p.items.slice(0,2).map((i) => (
                            <li key={i}>✓ {i}</li>
                          ))}
                        </ul>
                        <button className="w-full bg-green-700 text-white py-1 rounded text-xs">
                          Başvur
                        </button>
                      </div>
                    ))}
                  </div>
                </div>

              </div>

            </div>
          </div>
        )}

        {page === "features" && (
          <div className="mx-auto max-w-7xl h-full w-full p-6 overflow-auto public-page-shell">
            <div className="text-center mb-8">
              <div className="text-xs uppercase tracking-widest bg-green-100 text-green-700 inline-block px-3 py-1 rounded-full">
                Sistem Özellikleri
              </div>
              <h2 className="font-black text-3xl mt-3">ZeytinHesap ile Alım Süreci Çok Daha Kolay</h2>
              <p className="text-stone-500 mt-2 text-sm">
                Zeytin alım sürecini hızlandıran ve tüm verileri tek panelde toplayan güçlü özellikler.
              </p>
            </div>

            <div className="grid md:grid-cols-3 gap-6">
              {features.map((f) => (
                <div key={f.title} className="bg-white p-6 rounded-2xl shadow border border-stone-200 hover:shadow-lg transition">
                  <div className="w-10 h-10 bg-green-100 text-green-700 flex items-center justify-center rounded-lg mb-3 text-lg">
                    🌿
                  </div>
                  <div className="font-bold text-lg mb-2">{f.title}</div>
                  <div className="text-sm text-stone-600 leading-relaxed">{f.text}</div>
                </div>
              ))}
            </div>

            <div className="grid md:grid-cols-3 gap-4 mt-8 text-center">
              <div className="bg-green-50 p-4 rounded-xl">⚡ Hızlı veri girişi</div>
              <div className="bg-green-50 p-4 rounded-xl">📊 Anlık raporlar</div>
              <div className="bg-green-50 p-4 rounded-xl">☁️ Güvenli veri saklama</div>
            </div>
          </div>
        )}

        {page === "demo" && (
          <div className="mx-auto max-w-7xl w-full grid grid-cols-5 gap-2 p-2 overflow-hidden items-stretch" style={{height: "calc(100vh - 56px - 28px)"}}>
            {/* Satıcı Yönetimi */}
            <div className="bg-white rounded-2xl p-3 shadow border border-stone-200 flex flex-col hover:shadow-lg transition relative overflow-hidden h-full min-h-0">
              <div className="absolute -right-10 -top-10 w-32 h-32 bg-green-100 rounded-full blur-2xl opacity-40"></div>
              <div className="absolute -left-10 -bottom-10 w-32 h-32 bg-lime-100 rounded-full blur-2xl opacity-40"></div>
              <div className="flex items-center gap-2 mb-3">
                <div className="w-7 h-7 bg-green-100 rounded-lg flex items-center justify-center text-sm">👤</div>
                <div className="font-bold text-base">Satıcı Yönetimi</div>
              </div>
              <div className="grid gap-2 mb-3">
                <input className="w-full p-2 border rounded text-sm" placeholder="Ad Soyad" value={sellerName} onChange={(e)=>setSellerName(e.target.value)} />
                <input className="w-full p-2 border rounded text-sm" placeholder="Telefon" value={sellerPhone} onChange={(e)=>setSellerPhone(e.target.value)} />
                <button onClick={addSeller} className="w-full bg-green-700 text-white p-2 rounded text-sm font-semibold hover:bg-green-800 transition">Satıcı Ekle</button>
              </div>
              <div className="font-semibold text-xs text-stone-500 uppercase mb-2">Satıcı Listesi</div>
              <div className="space-y-1 mb-3">
                {sellers.map((s)=>(
                  <div key={s.name} className="flex items-center justify-between bg-green-50 border border-green-100 rounded-lg px-2 py-1 text-xs">
                    <span className="font-medium min-w-0 truncate pr-2">{s.name}</span>
                    <span className="text-green-700 font-bold whitespace-nowrap">{Math.round(s.kg)} kg</span>
                  </div>
                ))}
              </div>
              <div className="mt-auto grid grid-cols-2 gap-2 pt-3 border-t border-stone-100">
                <div className="bg-green-50 rounded-lg p-2 text-center">
                  <div className="text-lg font-black text-green-700">{sellers.length}</div>
                  <div className="text-xs text-stone-500">Toplam Satıcı</div>
                </div>
                <div className="bg-lime-50 rounded-lg p-2 text-center">
                  <div className="text-lg font-black text-lime-700">{totalKg} kg</div>
                  <div className="text-xs text-stone-500">Toplam Alım</div>
                </div>
              </div>
            </div>

            {/* Teslim Yönetimi */}
            <div className="bg-white rounded-2xl p-3 shadow border border-stone-200 flex flex-col hover:shadow-lg transition h-full min-h-0 overflow-hidden">
              <div className="flex items-center gap-2 mb-3">
                <div className="w-7 h-7 bg-blue-100 rounded-lg flex items-center justify-center text-sm">📦</div>
                <div className="font-bold text-base">Teslim Yönetimi</div>
              </div>
              <div className="grid gap-2 mb-3">
                <select className="w-full p-2 border rounded text-sm bg-white" value={deliverySeller} onChange={(e)=>setDeliverySeller(e.target.value)}>
                  <option value="">Satıcı Seç</option>
                  {sellerOptions.map((name)=>(
                    <option key={name} value={name}>{name}</option>
                  ))}
                </select>
                <select className="w-full p-2 border rounded text-sm bg-white" value={deliveryType} onChange={(e)=>setDeliveryType(e.target.value)}>
                  <option value="">Zeytin Çeşidi Seç</option>
                  {oliveTypes.map((type) => (
                    <option key={type}>{type}</option>
                  ))}
                </select>
                <input className="w-full p-2 border rounded text-sm" placeholder="Kg" value={deliveryKg} onChange={(e)=>setDeliveryKg(e.target.value)} />
                <button onClick={addDelivery} className="w-full bg-green-700 text-white p-2 rounded text-sm font-semibold hover:bg-green-800 transition">Teslim Ekle</button>
              </div>
              <div className="font-semibold text-xs text-stone-500 uppercase mb-2">Teslim Listesi</div>
              <div className="grid [grid-template-columns:minmax(0,1.4fr)_minmax(0,1fr)_auto] text-[10px] text-stone-400 px-2 mb-1 gap-1">
                <span className="truncate">Satıcı</span>
                <span className="text-center truncate">Çeşit</span>
                <span className="text-right whitespace-nowrap">Kg</span>
              </div>
              <div id="delivery-list" className="space-y-1 mb-3">
                {sortedAllDeliveries.map((d,i)=>(
                  <div key={i} className="grid [grid-template-columns:minmax(0,1.4fr)_minmax(0,1fr)_auto] items-center bg-blue-50 border border-blue-100 rounded-lg px-2 py-1 text-xs gap-1">
                    <span className="font-medium min-w-0 truncate" title={d.seller}>{d.seller}</span>
                    <span className="text-center text-stone-600 min-w-0 truncate" title={d.type || "-"}>{d.type || "-"}</span>
                    <span className="text-right text-blue-700 font-bold whitespace-nowrap">{Math.round(Number(d.kg || 0))} kg</span>
                  </div>
                ))}
              </div>
              <div className="mt-auto pt-3 border-t border-stone-100">
                <div className="bg-gradient-to-r from-green-50 to-lime-50 border border-green-200 rounded-lg p-2 text-center">
                  <div className="text-xs text-stone-500">Günlük Toplam Teslim</div>
                  <div className="text-xl font-black text-green-700">{Math.round(totalKg)} kg</div>
                </div>
              </div>
            </div>

            {/* Hesap Tablosu */}
            <div className="bg-white rounded-2xl p-3 shadow border border-stone-200 flex flex-col hover:shadow-lg transition h-full min-h-0 overflow-hidden">
              <div className="flex items-center gap-2 mb-3">
                <div className="w-7 h-7 bg-yellow-100 rounded-lg flex items-center justify-center text-sm">🧮</div>
                <div className="font-bold text-base">Hesap Tablosu</div>
              </div>
              <table className="w-full text-[10px] mb-2">
                <thead className="bg-stone-100">
                  <tr>
                    <th className="p-2 text-left rounded-l">Sınıf</th>
                    <th className="text-center">Kg</th>
                    <th className="text-center">Fiyat</th>
                    <th className="text-right rounded-r">Toplam</th>
                  </tr>
                </thead>
                <tbody>
                  {distributedClasses.map((c) => (
                    <tr key={c.label} className="border-t">
                      <td className="p-2 font-medium">{c.label}</td>
                      <td className="text-center font-semibold">{Math.round(c.calcKg)}</td>
                      <td className="text-center font-semibold text-green-700">₺{c.price}</td>
                      <td className="text-right font-semibold">₺{Math.round(c.calcKg * c.price).toLocaleString("tr-TR")}</td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr className="border-t font-bold bg-green-50">
                    <td className="p-2">Toplam</td>
                    <td className="text-center">{totalKg}</td>
                    <td className="text-center text-xs">Ort. ₺{avgPrice}</td>
                    <td className="text-right text-green-700">₺{totalAmount.toLocaleString("tr-TR")}</td>
                  </tr>
                </tfoot>
              </table>
              <div className="mt-auto space-y-2 pt-3 border-t border-stone-100">
                <div className="text-xs text-stone-500 font-semibold uppercase mb-1">Sınıf Dağılımı (1 Kasa = 22 kg)</div>
                {distributedClasses.map((c)=>(
                  <div key={c.label} className="flex items-center gap-2 text-xs">
                    <span className="w-10 text-stone-600 shrink-0">{c.label}</span>
                    <div className="flex-1 bg-stone-100 rounded-full h-2">
                      <div className="bg-green-500 h-2 rounded-full" style={{width: totalCrates ? `${Math.round((c.calcKg / kgPerCrate) / totalCrates * 100)}%` : "0%"}}></div>
                    </div>
                    <span className="w-14 text-right text-stone-500">{(c.calcKg / kgPerCrate).toFixed(1)} kasa</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Rapor Özeti */}
            <div className="bg-white rounded-2xl p-3 shadow border border-stone-200 flex flex-col hover:shadow-lg transition h-full min-h-0 overflow-hidden">
              <div className="flex items-center gap-2 mb-3">
                <div className="w-7 h-7 bg-purple-100 rounded-lg flex items-center justify-center text-sm">📊</div>
                <div className="font-bold text-base">Rapor Özeti</div>
              </div>
              <div className="text-xs font-semibold text-stone-500 uppercase mb-2">Çeşit Toplamları</div>
              <table className="w-full text-[10px] mb-2">
                <thead className="bg-stone-100">
                  <tr>
                    <th className="p-2 text-left rounded-l">Sınıf</th>
                    <th className="text-center">Kg</th>
                    <th className="text-center">Fiyat</th>
                    <th className="text-right rounded-r">Toplam</th>
                  </tr>
                </thead>
                <tbody>
                  {distributedClasses.map((c) => (
                    <tr key={c.label} className="border-t">
                      <td className="p-2 font-medium">{c.label}</td>
                      <td className="text-center font-semibold">{Math.round(c.calcKg)}</td>
                      <td className="text-center font-semibold text-green-700">₺{c.price}</td>
                      <td className="text-right font-semibold">₺{Math.round(c.calcKg * c.price).toLocaleString("tr-TR")}</td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr className="border-t font-bold bg-green-50">
                    <td className="p-2">Toplam</td>
                    <td className="text-center">{Math.round(totalKg)}</td>
                    <td className="text-center text-xs">Ort. ₺{avgPrice}</td>
                    <td className="text-right text-green-700">₺{totalAmount.toLocaleString("tr-TR")}</td>
                  </tr>
                </tfoot>
              </table>
              <div className="text-xs font-semibold text-stone-500 uppercase mb-2">Zeytin Çeşidine Göre Alım</div>
              <div className="space-y-1 mb-3">
                {varietyTotals.map((v) => (
                  <div key={v.type} className="flex justify-between bg-stone-50 border border-stone-100 rounded-lg px-2 py-1 text-xs">
                    <span className="font-medium">{v.type}</span>
                    <span className="text-green-700 font-bold">{Math.round(v.kg)} kg</span>
                  </div>
                ))}
              </div>
              <div className="mt-auto space-y-2 pt-3 border-t border-stone-100">
                <div className="flex justify-between items-center bg-stone-50 border border-stone-200 rounded-lg px-3 py-2 text-sm">
                  <span className="text-stone-600">Toplam KG</span>
                  <span className="font-black text-stone-800">{totalKg} kg</span>
                </div>
                <div className="flex justify-between items-center bg-green-50 border border-green-200 rounded-lg px-3 py-2 text-sm">
                  <span className="text-stone-600">Toplam Tutar</span>
                  <span className="font-black text-green-700">₺{totalAmount.toLocaleString("tr-TR")}</span>
                </div>
                <div className="flex justify-between items-center bg-lime-50 border border-lime-200 rounded-lg px-3 py-2 text-sm">
                  <span className="text-stone-600">Ortalama Fiyat</span>
                  <span className="font-black text-lime-700">₺{avgPrice}</span>
                </div>
                <button className="w-full mt-1 bg-green-700 text-white py-2 rounded-lg text-xs font-semibold hover:bg-green-800 transition">📄 PDF Rapor Al</button>
              </div>
            </div>

            {/* Giderler */}
            <div className="bg-white rounded-2xl p-3 shadow border border-stone-200 flex flex-col hover:shadow-lg transition h-full min-h-0 overflow-hidden">
              <div className="flex items-center gap-2 mb-3">
                <div className="w-7 h-7 bg-red-100 rounded-lg flex items-center justify-center text-sm">💸</div>
                <div className="font-bold text-base">Giderler</div>
              </div>
              <table className="w-full text-[10px] mb-2">
                <thead className="bg-stone-100">
                  <tr>
                    <th className="p-2 text-left rounded-l">Gider Kalemi</th>
                    <th className="p-2 text-right rounded-r">Tutar</th>
                  </tr>
                </thead>
                <tbody>
                  {expenses.map((e) => (
                    <tr key={e.item} className="border-t">
                      <td className="p-2 font-medium">{e.item}</td>
                      <td className="p-2 text-right font-semibold text-red-600">₺{e.amount.toLocaleString("tr-TR")}</td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr className="border-t font-bold bg-red-50">
                    <td className="p-2">Toplam Gider</td>
                    <td className="p-2 text-right text-red-700">₺{totalExpenses.toLocaleString("tr-TR")}</td>
                  </tr>
                </tfoot>
              </table>
              <div className="text-xs font-semibold text-stone-500 uppercase mb-2">Teslimat</div>
              <div className="grid grid-cols-2 gap-2 mb-2">
                <input
                  className="col-span-2 w-full p-2 border rounded text-xs"
                  placeholder="Firma Adı"
                  value={assetCompany}
                  onChange={(e)=>setAssetCompany(e.target.value)}
                />
                <input
                  className="w-full p-2 border rounded text-xs"
                  placeholder="Kasa Adeti"
                  value={assetCrateCount}
                  onChange={(e)=>setAssetCrateCount(e.target.value)}
                />
                <select
                  className="w-full p-2 border rounded text-xs bg-white"
                  value={assetType}
                  onChange={(e)=>setAssetType(e.target.value)}
                >
                  <option value="">Zeytin Çeşidi Seç</option>
                  {oliveTypes.map((type) => (
                    <option key={`asset-${type}`}>{type}</option>
                  ))}
                </select>
                <input
                  className="w-full p-2 border rounded text-xs"
                  placeholder="KG"
                  value={assetKg}
                  onChange={(e)=>setAssetKg(e.target.value)}
                />
                <input
                  className="w-full p-2 border rounded text-xs"
                  placeholder="Fiyat"
                  value={assetPrice}
                  onChange={(e)=>setAssetPrice(e.target.value)}
                />
                <button
                  className="col-span-2 w-full bg-red-600 text-white p-2 rounded text-xs font-semibold hover:bg-red-700 transition"
                  onClick={addAsset}
                >
                  Kaydet
                </button>
              </div>
              <div className="space-y-1 mb-3 max-h-24 overflow-auto pr-1">
                {assets.map((a, i) => (
                  <div key={`${a.company}-${i}`} className="bg-red-50 border border-red-100 rounded-lg px-2 py-2 text-[11px] flex flex-col md:grid md:[grid-template-columns:minmax(0,1.3fr)_auto_minmax(0,1fr)_auto_auto] md:gap-1">
                    <div className="flex flex-col md:flex-row md:items-center md:gap-1">
                      <span className="truncate font-semibold text-red-700" title={a.company}>{a.company}</span>
                      <span className="text-center md:ml-2 whitespace-nowrap">{a.crateCount} kasa</span>
                      <span className="text-center md:ml-2 truncate" title={a.type}>{a.type}</span>
                    </div>
                    <div className="flex flex-row justify-between mt-1 md:mt-0">
                      <span className="text-right whitespace-nowrap">{a.kg} kg</span>
                      <span className="text-right font-semibold text-red-700 whitespace-nowrap md:ml-2">₺{a.price}</span>
                    </div>
                  </div>
                ))}
              </div>
              <div className="mt-auto space-y-2 pt-3 border-t border-stone-100">
                <div className="flex justify-between items-center bg-stone-50 border border-stone-200 rounded-lg px-3 py-2 text-sm">
                  <span className="text-stone-600">Brüt Tutar</span>
                  <span className="font-black text-stone-800">₺{totalAmount.toLocaleString("tr-TR")}</span>
                </div>
                <div className="flex justify-between items-center bg-red-50 border border-red-200 rounded-lg px-3 py-2 text-sm">
                  <span className="text-stone-600">Toplam Gider</span>
                  <span className="font-black text-red-700">₺{totalExpenses.toLocaleString("tr-TR")}</span>
                </div>
                <div className="flex justify-between items-center bg-green-50 border border-green-200 rounded-lg px-3 py-2 text-sm">
                  <span className="text-stone-600">Net Tutar</span>
                  <span className="font-black text-green-700">₺{netAmount.toLocaleString("tr-TR")}</span>
                </div>
                <div className="flex justify-between items-center bg-red-50 border border-red-200 rounded-lg px-3 py-2 text-sm">
                  <span className="text-stone-600">Teslimat Toplam</span>
                  <span className="font-black text-red-700">₺{totalAssetAmount.toLocaleString("tr-TR")}</span>
                </div>
              </div>
            </div>
          </div>
        )}

        {page === "register" && (
          <div className="mx-auto max-w-5xl h-full w-full flex items-center justify-center p-6 overflow-auto public-page-shell">
            <div className="relative w-full bg-gradient-to-br from-white to-green-50 rounded-3xl shadow-2xl border border-stone-200 p-12 overflow-hidden">
              <div className="absolute -top-20 -right-20 w-72 h-72 bg-green-200 rounded-full blur-3xl opacity-40"></div>
              <div className="absolute -bottom-20 -left-20 w-72 h-72 bg-lime-200 rounded-full blur-3xl opacity-40"></div>

              {isRegisterSectionDisabled && (
                <div className="absolute inset-0 z-20 pointer-events-none flex items-center justify-center overflow-hidden rounded-3xl">
                  <div className="w-[170%] -rotate-[18deg] bg-white/85 backdrop-blur-sm text-center py-6 md:py-8 shadow-2xl border-y-2 border-yellow-400/60">
                    <div className="text-base md:text-2xl font-black tracking-widest uppercase" style={{color:'#e65c00', textShadow:'0 1px 4px rgba(0,0,0,0.18)'}}>İLETİŞİM: 0507 117 69 97</div>
                    <div className="text-lg md:text-4xl font-black tracking-wide uppercase text-green-900 mt-1">YAPIM AŞAMASINDAYIZ</div>
                    <div className="text-sm md:text-2xl font-bold uppercase text-green-800 mt-1">09.09.2026 HİZMETİNİZDEYİZ</div>
                  </div>
                </div>
              )}

              <div className="text-center mb-12">
                <div className="text-xs uppercase tracking-widest bg-green-100 text-green-700 inline-block px-4 py-1 rounded-full shadow">
                  ZeytinHesap
                </div>
                <h2 className="text-4xl font-black mt-5">Kullanıcı Kaydı</h2>
                <p className="text-stone-500 text-sm mt-2 max-w-md mx-auto">
                  Zeytin alım takip sistemini kullanmak için kullanıcı hesabı oluşturabilirsiniz.
                </p>
              </div>

              <div className="grid md:grid-cols-2 gap-10 items-center">
                <div className="space-y-4">
                  <div className="bg-white p-4 rounded-xl border shadow-sm flex items-center gap-3">
                    <div className="text-2xl">⚡</div>
                    <div className="text-sm font-semibold">Hızlı satıcı kayıt sistemi</div>
                  </div>
                  <div className="bg-white p-4 rounded-xl border shadow-sm flex items-center gap-3">
                    <div className="text-2xl">📊</div>
                    <div className="text-sm font-semibold">Otomatik hesaplama ve raporlar</div>
                  </div>
                  <div className="bg-white p-4 rounded-xl border shadow-sm flex items-center gap-3">
                    <div className="text-2xl">☁️</div>
                    <div className="text-sm font-semibold">Bulut tabanlı güvenli sistem</div>
                  </div>
                </div>

                <div className="bg-white p-6 rounded-2xl border shadow-lg space-y-4">
                  <div>
                    <div className="text-xs text-stone-500 mb-1">Ad Soyad</div>
                    <input
                      type="text"
                      placeholder="Ad Soyad"
                      value={registerName}
                      onChange={(e) => setRegisterName(e.target.value)}
                      disabled={isRegisterSectionDisabled}
                      className="w-full p-3 rounded-lg border bg-white text-center font-semibold disabled:opacity-50 disabled:cursor-not-allowed"
                    />
                  </div>
                  <div>
                    <div className="text-xs text-stone-500 mb-1">E-posta</div>
                    <input
                      type="email"
                      placeholder="ornek@mail.com"
                      value={registerEmail}
                      onChange={(e) => setRegisterEmail(e.target.value)}
                      disabled={isRegisterSectionDisabled}
                      className="w-full p-3 rounded-lg border bg-white text-center font-semibold disabled:opacity-50 disabled:cursor-not-allowed"
                    />
                  </div>
                  <div>
                    <div className="text-xs text-stone-500 mb-1">Telefon (opsiyonel)</div>
                    <input
                      type="text"
                      placeholder="05xx xxx xx xx"
                      value={registerPhone}
                      onChange={(e) => setRegisterPhone(e.target.value)}
                      disabled={isRegisterSectionDisabled}
                      className="w-full p-3 rounded-lg border bg-white text-center font-semibold disabled:opacity-50 disabled:cursor-not-allowed"
                    />
                  </div>
                  <div>
                    <div className="text-xs text-stone-500 mb-1">Şifre</div>
                    <input
                      type="password"
                      placeholder="Şifre"
                      value={registerPassword}
                      onChange={(e) => setRegisterPassword(e.target.value)}
                      disabled={isRegisterSectionDisabled}
                      className="w-full p-3 rounded-lg border bg-white text-center font-semibold disabled:opacity-50 disabled:cursor-not-allowed"
                    />
                  </div>
                  {registerError && (
                    <div className="text-xs text-red-700 bg-red-50 border border-red-200 rounded-lg px-3 py-2 text-center">
                      {registerError}
                    </div>
                  )}
                  {registerSuccess && (
                    <div className="text-xs text-green-700 bg-green-50 border border-green-200 rounded-lg px-3 py-2 text-center">
                      {registerSuccess}
                    </div>
                  )}
                  <button
                    type="button"
                    onClick={handleRegister}
                    disabled={isRegisterLoading || isRegisterSectionDisabled}
                    className="w-full bg-green-700 text-white p-3 rounded-xl font-bold tracking-wide hover:bg-green-800 transition disabled:opacity-60 disabled:cursor-not-allowed uppercase"
                  >
                    {isRegisterSectionDisabled ? "YAPIM AŞAMASINDAYIZ" : isRegisterLoading ? "KAYDEDİLİYOR..." : "KAYIT OLUŞTUR"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {page === "contact" && (
          <div className="mx-auto max-w-7xl w-full p-4 flex flex-col gap-3 public-page-shell" style={{height: "calc(100vh - 56px - 28px)"}}>
            <div className="w-full grid md:grid-cols-2 gap-4 items-stretch">
              <div className="bg-gradient-to-br from-green-800 via-green-700 to-lime-600 text-white rounded-2xl p-5 shadow-2xl border border-green-500 flex flex-col justify-between">
                <div>
                  <div className="text-xs uppercase tracking-widest text-green-100 bg-green-900/40 inline-block px-3 py-1 rounded-full">ZeytinHesap</div>
                  <h2 className="text-2xl font-black mt-3 leading-tight">
                    Zeytin Alımınızı<br />Tek Panelden<br />Yönetin
                  </h2>
                  <p className="text-green-100 text-sm mt-2 leading-relaxed">
                    Satıcı kayıtları, kilogram hesaplama, teslim alımı ve günlük raporları tek panelde yönetin. 7 gün ücretsiz deneyin.
                  </p>
                  <div className="grid grid-cols-3 gap-2 mt-3 text-xs text-center">
                    <div className="bg-green-900/40 p-2 rounded-lg">⚡ Hızlı kayıt</div>
                    <div className="bg-green-900/40 p-2 rounded-lg">📊 Raporlama</div>
                    <div className="bg-green-900/40 p-2 rounded-lg">☁️ Bulut sistem</div>
                  </div>
                </div>
                <div className="mt-4">
                  <div className="text-2xl font-black tracking-wide">0507 117 69 97</div>
                  <button
                    className="mt-3 bg-white text-green-900 px-6 py-2 rounded-xl font-bold shadow-lg hover:scale-105 transition"
                    onClick={() => (window.location.href = "tel:05071176997")}
                  >
                    Hemen Ara
                  </button>
                  <div className="text-xs text-green-100 mt-2">3 Gün ücretsiz demo</div>
                </div>
              </div>
              <div className="bg-white rounded-2xl p-5 shadow border border-stone-200 flex flex-col justify-between">
                <div>
                  <div className="text-xs uppercase tracking-widest bg-green-100 text-green-700 inline-block px-3 py-1 rounded-full">Kullanım Paketleri</div>
                  <h2 className="text-xl font-black mt-3">İşletmenize Uygun Paket</h2>
                  <p className="text-sm text-stone-500 mt-1">Zeytin alım yapan işletmeler için özel geliştirilmiş sistem.</p>
                </div>
                <div className="grid grid-cols-3 gap-3 mt-4">
                  <div className="bg-green-50 border border-green-200 rounded-xl p-3 text-center flex flex-col items-center gap-1">
                    <div className="text-2xl">⚡</div>
                    <div className="font-bold text-xs text-green-800">Kurulum Yok</div>
                    <div className="text-xs text-stone-500">Hemen kullanmaya başla</div>
                  </div>
                  <div className="bg-green-50 border border-green-200 rounded-xl p-3 text-center flex flex-col items-center gap-1">
                    <div className="text-2xl">🔒</div>
                    <div className="font-bold text-xs text-green-800">Güvenli Veri</div>
                    <div className="text-xs text-stone-500">Şifreli bulut depolama</div>
                  </div>
                  <div className="bg-green-50 border border-green-200 rounded-xl p-3 text-center flex flex-col items-center gap-1">
                    <div className="text-2xl">📊</div>
                    <div className="font-bold text-xs text-green-800">PDF Rapor</div>
                    <div className="text-xs text-stone-500">Günlük rapor çıktısı</div>
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-3 mt-3">
                  <div className="bg-stone-50 border border-stone-200 rounded-xl p-3 text-center flex flex-col items-center gap-1">
                    <div className="text-2xl">📱</div>
                    <div className="font-bold text-xs text-stone-700">Mobil Uyumlu</div>
                    <div className="text-xs text-stone-500">Her cihazdan erişim</div>
                  </div>
                  <div className="bg-stone-50 border border-stone-200 rounded-xl p-3 text-center flex flex-col items-center gap-1">
                    <div className="text-2xl">🎧</div>
                    <div className="font-bold text-xs text-stone-700">Teknik Destek</div>
                    <div className="text-xs text-stone-500">0507 117 69 97</div>
                  </div>
                </div>
                <div className="mt-3 bg-gradient-to-r from-green-700 to-lime-600 rounded-xl p-3 text-white text-center">
                  <div className="font-black text-base">3 Gün Ücretsiz Deneyin</div>
                  <div className="text-xs text-green-100 mt-1">Kredi kartı gerekmez · Hemen başlayın</div>
                </div>
              </div>
            </div>
            <div className="grid md:grid-cols-3 gap-4">
              {packages.map((p) => (
                <div key={p.name} className="bg-white rounded-2xl p-4 shadow border border-stone-200 flex flex-col hover:shadow-lg transition">
                  <div className="flex items-center justify-between mb-2">
                    <div className="font-bold text-base">{p.name}</div>
                    <div className="text-green-700 font-semibold text-xs">{p.price}</div>
                  </div>
                  <ul className="text-sm text-stone-600 mb-3 space-y-1">
                    {p.items.map((i) => (
                      <li key={i}>✓ {i}</li>
                    ))}
                  </ul>
                  <button className="w-full bg-green-700 text-white px-4 py-2 rounded-lg text-sm font-semibold hover:bg-green-800 transition mt-auto">
                    Başvur
                  </button>
                </div>
              ))}
            </div>
          </div>
        )}
      </main>

      <footer className="text-center text-xs py-2 bg-black text-stone-400 shrink-0">
        © {new Date().getFullYear()} zeytinhesap.com
      </footer>
    </div>
  );
}
